import { Rout_create } from './Rout.create'
import { Rout_to } from './Rout'
import type { AutoOpen } from '../Note/Note.AutoOpenPlugin'

export interface Route_NoteRouteArgs {
    Note_NewNotePage: React.FunctionComponent<unknown>
    Note_NotebookPage: React.FunctionComponent<unknown>
}

export const Rout_NoteRoutes = (args: Route_NoteRouteArgs) => [
    Rout_create('/note/new', args.Note_NewNotePage),
    Rout_create('/notebook', args.Note_NotebookPage),
]

export function Rout_toNewNote(autoOpen: AutoOpen) {
    Rout_to('/note/new', { autoOpen })
}

export function Rout_toNotebook() {
    Rout_to('/notebook')
}
